import { FETCH_SHELF_LIFE_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
};

const shelfLifeListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHELF_LIFE_LIST:
      return { list: action.payload };
    default:
      return state;
  }
};

export default shelfLifeListReducer;
